import api from '../../utils/api'

export const state = {
  instructionalVideosByTab: [],
  instructionalVideosByUser: []
}

export const mutations = {
  SET_INSTRUCTIONAL_VIDEOS_BY_TAB(state, instructionalVideosByTab) {
    state.instructionalVideosByTab = instructionalVideosByTab
  },
  SET_INSTRUCTIONAL_VIDEOS_BY_USER(state, instructionalVideosByUser) {
    state.instructionalVideosByUser = instructionalVideosByUser
  }
}

export const actions = {
  async handleCreate(_, body) {
    try {
      return await api.post('/instructional-video', body)
    } catch (e) {

    }
  },

  async handleUpdate(_, body) {
    try {
      return await api.put(`/instructional-video/${body._id}`, body)
    } catch (e) {

    }
  },

  async handleGet(_, _id) {
    try {
      return await api.get(`/instructional-video/${_id}`)
    } catch (e) {

    }
  },

  async handleGetByTab({ commit }, tab) {
    try {
      const { data } = await api.get(`/instructional-video/tab/${tab}`)
      const { items } = data
      commit('SET_INSTRUCTIONAL_VIDEOS_BY_TAB', items)
      return items
    } catch (e) {

    }
  },

  async handleGetByUser({ commit }, userId) {
    try {
      const { data } = await api.get(`/instructional-video/user/${userId}`)
      const { items } = data
      commit('SET_INSTRUCTIONAL_VIDEOS_BY_USER', items)
      return items
    } catch (e) {

    }
  },

  async handleUpdateViewed(_, userId) {
    try {
      return await api.put(`/instructional-video/${userId}/viewed`)
    } catch (e) {

    }
  },

  async handleDelete(_, _id) {
    try {
      return await api.delete(`/instructional-video/${_id}`)
    } catch (e) {

    }
  },

  async handlePagedList(_, payload) {
    try {

      const params = new URLSearchParams()
      if (payload.page) {
        params.set('page', payload.page)
      }
      if (payload.limit) {
        params.set('limit', payload.limit)
      }
      if (payload.triggerTags) {
        params.set('triggerTags', payload.triggerTags)
      }
      if (payload.tab) {
        params.set('tab', payload.tab)
      }
      const { data: response } = await api.get(`/instructional-video?${params.toString()}`)
      return response
    } catch (e) {

    }
  },

  async handleSetInstructionalVideosByTab({ commit }) {
    try {
      commit('SET_INSTRUCTIONAL_VIDEOS_BY_TAB', [])
    } catch (e) {

    }
  },
}

export const getters = {
  instructionalVideosByTab: (state) => state.instructionalVideosByTab,
  instructionalVideosByUser: (state) => state.instructionalVideosByUser,
}
